// extracted by mini-css-extract-plugin
export default {"headingGrid":"AddEntryPriceModal_headingGrid__EA9Ko","rowGrid":"AddEntryPriceModal_rowGrid__MxZ6t"};